
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  GivenProfileViewsRequest,
} from '../models';
import {
    GivenProfileViewsRequestFromJSON,
    GivenProfileViewsRequestToJSON,
} from '../models';

export interface IncrementProfileViewsForConnectedIdentityRequest {
    givenProfileViewsRequest: GivenProfileViewsRequest;
}

/**
 * 
 */
export class SearchFixturesApi extends runtime.BaseAPI {

    /**
     * Increment the profile views counter for the connected identity
          */
    async incrementProfileViewsForConnectedIdentityRaw(requestParameters: IncrementProfileViewsForConnectedIdentityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['givenProfileViewsRequest'] == null) {
            throw new runtime.RequiredError(
                'givenProfileViewsRequest',
                'Required parameter "givenProfileViewsRequest" was null or undefined when calling incrementProfileViewsForConnectedIdentity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/search/test-fixtures/given-profile-views`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GivenProfileViewsRequestToJSON(requestParameters['givenProfileViewsRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Increment the profile views counter for the connected identity
          */
    async incrementProfileViewsForConnectedIdentity(requestParameters: IncrementProfileViewsForConnectedIdentityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.incrementProfileViewsForConnectedIdentityRaw(requestParameters, initOverrides);
    }

}
